export default function P02MainIdle({ isAdmin, onRegisterClick, onManageClick }) {
  if (isAdmin) {
    return (
      <div className="ev-admin-wrap">
        <p className="ev-admin-panel-title">관리자 패널</p>
        <div className="ev-card" style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
            <span className="ev-status-badge ev-status-idle">● 대기 중 (IDLE)</span>
          </div>
          <p style={{ fontSize: '0.85rem', color: 'var(--text-sub)' }}>
            투표를 시작하려면 최소 2명의 후보자를 등록해야 합니다.
          </p>
        </div>
        <div className="ev-admin-btns">
          <button className="ev-admin-btn-card" onClick={onRegisterClick}>
            <div className="ev-admin-btn-icon">📋</div>
            <div className="ev-admin-btn-label">후보자 등록</div>
            <div className="ev-admin-btn-desc">후보자 이름·사진·소개를 등록합니다</div>
          </button>
          <button className="ev-admin-btn-card" onClick={onManageClick}>
            <div className="ev-admin-btn-icon">▶</div>
            <div className="ev-admin-btn-label">투표 시작 관리</div>
            <div className="ev-admin-btn-desc">투표를 시작하거나 현황을 관리합니다</div>
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="ev-voter-idle">
      <div className="ev-voter-idle-icon">🗳️</div>
      <p className="ev-voter-idle-text">현재 진행 중인 투표가 없습니다.</p>
      <p className="ev-voter-idle-sub">투표가 시작되면 이 화면이 자동으로 바뀝니다.</p>
    </div>
  );
}
